import React from 'react';
import whatsappUrl from '../assets/whatsapp.webp';
import callUrl from '../assets/call.png';

// Brand channel icons (raster). Used everywhere a WhatsApp or call/phone
// affordance appears — no text labels.
export const WhatsAppIcon: React.FC<{ className?: string }> = ({ className = 'w-5 h-5' }) => (
  <img src={whatsappUrl} alt="WhatsApp" className={`${className} object-contain`} />
);

export const CallIcon: React.FC<{ className?: string }> = ({ className = 'w-5 h-5' }) => (
  <img src={callUrl} alt="Call" className={`${className} object-contain`} />
);
